module.exports = __webpack_public_path__ + "img/no-time-off.5f82fa75.png";